import { router } from "@inertiajs/react";
import { Grid } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

import { formatDate } from "../../lib/format";
import { Event } from "../../types/Event";
import Heading from "../theme/Heading";

const EventList = ({ events }: { events: Event[] }) => {
  if (events.length === 0) {
    return (
      <Typography marginBottom="2em" marginTop="1em">
        Er zijn nog geen toekomstige demonstraties toegevoegd. Neem contact op
        om een demonstratie aan te melden.
      </Typography>
    );
  }

  return (
    <Grid container spacing="2em" sx={{ marginTop: "1em" }}>
      {events.map((event) => (
        <Grid key={event.slug} size={{ xs: 12, sm: 6 }}>
          <Card
            sx={{
              cursor: "pointer",
            }}
            onClick={() => router.visit(`/events/${event.slug}`)}
          >
            <CardMedia
              alt={event.name}
              component="img"
              height="194"
              image={event.coverUrl}
            />
            <Heading padding="16px 16px 0" variant="h2">
              {event.name}
            </Heading>
            <CardContent>
              <Typography sx={{ color: "text.secondary" }} variant="body2">
                {formatDate(event.startsAt)}, {event.locationHuman}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default EventList;
